import * as React from 'react';
import { ProgressBar as BWProgressBar } from 'baseui/progress-bar';

const ProgressBar = ({ ...props }) => {
  return <BWProgressBar {...props} />;
};

export default ProgressBar;
